import { memo } from "react";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

// When the lazy function is loading a heavy component this spinner is on the page
const Loading = ({ loadingColor, fontSize, loadingText }) => {
  return (
    <>
      <Col className="d-flex flex-column justify-content-center align-items-center text-center">
        <Spinner animation="border" variant={loadingColor}>
          
          {/* This span is hidden and helps page readers */}
          <span className="visually-hidden">{loadingText}</span>
          
        </Spinner>
        <span className={`text-${loadingColor} fs-${fontSize}`}>{loadingText}</span>
      </Col>
    </>
  );
};

export default memo(Loading);
